import { useEffect } from "react";
import { Calendar } from "lucide-react";
import Navigation from "@/components/Navigation";
import FooterAlt from "@/components/FooterAlt";

const Schedule = () => {
  useEffect(() => {
    document.title = "Schedule Meeting with Arun Mohan | AMX Ventures";
    const desc = "Connect with Arun Mohan, experienced founder with 2 exits (Adfolks, AppsIntegra), to discuss ecosystem-first growth strategies and funding for your startup.";
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.href);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <section className="py-20 px-4 bg-gradient-to-b from-background to-secondary/10">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 mb-6">
                <Calendar className="w-8 h-8 text-accent" />
              </div>
              <h1 className="text-4xl md:text-5xl font-black text-foreground mb-6">
                Schedule a Meeting
              </h1>
              <div className="max-w-3xl mx-auto space-y-6">
                <p className="text-xl text-foreground leading-relaxed">
                  Connect with Arun Mohan, experienced founder with 2 exits (Adfolks, AppsIntegra), to discuss ecosystem-first growth strategies and funding for your startup.
                </p>
                <div className="grid md:grid-cols-3 gap-6 text-left">
                  <div className="p-6 bg-secondary border-l-4 border-accent">
                    <h3 className="font-black text-lg text-foreground mb-2">For Founders</h3>
                    <p className="text-sm text-muted-foreground">
                      Discuss partnership-driven capital, hyperscaler GTM strategies, and how to achieve 90% CAC reduction through ecosystem alignment
                    </p>
                  </div>
                  <div className="p-6 bg-secondary border-l-4 border-primary">
                    <h3 className="font-black text-lg text-foreground mb-2">For Ecosystem Partners</h3>
                    <p className="text-sm text-muted-foreground">
                      Explore co-selling opportunities with our portfolio companies across AWS, Azure, Google Cloud, Oracle, and Salesforce ecosystems
                    </p>
                  </div>
                  <div className="p-6 bg-secondary border-l-4 border-accent">
                    <h3 className="font-black text-lg text-foreground mb-2">For Enterprise Customers</h3>
                    <p className="text-sm text-muted-foreground">
                      Learn about innovative B2B SaaS solutions from our portfolio optimized for hyperscaler marketplaces and enterprise procurement
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-center">
              <div className="w-full max-w-[800px] rounded-lg overflow-hidden border-2 border-border hover:border-accent/50 transition-colors bg-card shadow-lg">
                <iframe
                  src="https://amxventures.pipedrive.com/scheduler/a2mRmAUZ/arun-mohanam-meeting"
                  title="Pipedrive Scheduler - Arun Mohanam Meeting"
                  className="w-full h-[600px] border-0"
                  sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterAlt />
    </div>
  );
};

export default Schedule;
